/**
 * Created by Daisoras on 2020-07-07.
 * @link http://www.daisoras.com
 *
 */

const getCookie = function (name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return JSON.parse(decodeURIComponent(parts.pop().split(';').shift()));
  }
};

(function (document, $) {
  const frontCookie = function () {
    if (!getCookie('cookie_notice_accepted')) {
      $('#cookie-notice').show();
    }
    if (!getCookie('close-cookie')) {
      $('#cookie-notice').show();
    }
    if (getCookie('close-cookie') === 'true' || getCookie('cookie_notice_accepted') === 'true') {
      $('#cookie-notice').hide();
    }
    if (getCookie('cookie_func') === 'false') {
      $('#func').prop('checked', false);
    }
    if (getCookie('cookie_3rd_stat') === 'false') {
      $('#cookie_3rd_stat').prop('checked', false);
    }
    if (getCookie('cookie_3rd_adv') === 'false') {
      $('#cookie_3rd_adv').prop('checked', false);
    }
    if (getCookie('cookie_func') === 'true') {
      $('#func').prop('checked', true);
    }
    if (getCookie('cookie_3rd_stat') === 'true') {
      $('#cookie_3rd_stat').prop('checked', true);
    }
    if (getCookie('cookie_3rd_adv') === 'true') {
      $('#cookie_3rd_adv').prop('checked', true);
    }
  };
  const setCookie = function (cname, cvalue, exdays) {
    let d; let
      expires;
    d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
  };

  $('.d-set-cookie').on('click', () => {
    $('#cookie-notice').hide();
    setCookie('cookie_notice_accepted', true, 365);
    setCookie('cookie_func', true, 365);
    setCookie('cookie_3rd_stat', true, 365);
    setCookie('cookie_3rd_adv', true, 365);
    setCookie('close-cookie', true, 365);
  });
  $('.d-reject-cookie').on('click', () => {
    $('#cookie-notice').hide();
    setCookie('cookie_notice_accepted', true);
    setCookie('cookie_func', false);
    setCookie('cookie_3rd_stat', false);
    setCookie('cookie_3rd_adv', false);
    setCookie('close-cookie', true, 365);
  });

  $('.d-settings-cookie').on('click', () => {
    setCookie('close-cookie', true, 365);
    $('.settings-bg').show();
  });

  $('.settings-bg').on('click', function (e) {
    if (e.target !== this) return;
    $('.settings-bg').hide();
  });
  $('.eucookie_close').on('click', function (e) {
    if (e.target !== this) return;
    $('.settings-bg').hide();
  });
  $('.cl-b').on('click', function (e) {
    if (e.target !== this) return;
    $('.settings-bg').hide();
  });
  $('.cookie_notice_close .cl-b').on('click', (e) => {
    $('#cookie-notice').hide();
    setCookie('close-cookie', true);
  });

  frontCookie();

  $('#eucookieform').on('submit', (e) => {
    e.preventDefault();
    const func = $('#func').prop('checked');
    const cookie_3rd_stat = $('#cookie_3rd_stat').prop('checked');
    const cookie_3rd_adv = $('#cookie_3rd_adv').prop('checked');

    if (!func) {
      setCookie('cookie_func', false, 365);
    } else {
      setCookie('cookie_func', true, 365);
    }

    if (!cookie_3rd_stat) {
      setCookie('cookie_3rd_stat', false, 365);
    } else {
      setCookie('cookie_3rd_stat', true, 365);
    }

    if (!cookie_3rd_adv) {
      setCookie('cookie_3rd_adv', false, 365);
    } else {
      setCookie('cookie_3rd_adv', true, 365);
    }
    setCookie('cookie_notice_accepted', true, 365);
    $('.settings-bg').hide();
    $('#cookie-notice').hide();
  });
}(document, jQuery));
